export const stylesTheme = {
  root: {
    fontFamily: "'Ubuntu', Arial, sans-serif",
  },
  uploadSubtitle: {
    lineHeight: "21px",
    marginBottom: "16px",
  },
};

export const stylesFixed = {
  boxHeader: {
    textAlign: "left",
    marginBottom: "36px",
  },
  title: {
    margin: 0,
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "24px",
    color: "#1E293B",
    fontFamily: "'Ubuntu', Arial, sans-serif",
  },
  subtitle: {
    margin: 0,
    marginTop: "2px",
    fontWeight: 400,
    color: "#525866",
    fontSize: "14px",
    lineHeight: "18px",
    fontFamily: "'Ubuntu', Arial, sans-serif",
  },
  uploadDragger: {
    border: "2px solid #DDDFE6",
    borderRadius: "12px",
    backgroundColor: "transparent",
  },
  wrapperUpload: {
    minHeight: "360px",
    padding: "54px 24px 40px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  boxUploadProgress: { marginBottom: "34px" },
  errorMessage: {
    fontWeight: 700,
    color: "#FF5978",
    fontSize: "16px",
    fontFamily: "'Ubuntu', Arial, sans-serif",
    marginBottom: "0.76rem",
    textAlign: "center",
  },
  draggerTitle: {
    margin: 0,
    fontWeight: 700,
    color: "#1E293B",
    fontFamily: "'Ubuntu', Arial, sans-serif",
    fontSize: "16px",
    lineHeight: "20px",
    textAlign: "center",
  },
  selectedFileName: {
    fontWeight: 700,
    color: "#00866D",
    fontFamily: "'Ubuntu', Arial, sans-serif",
    fontSize: "16px",
  },
  percentProgress: {
    width: "70%",
    margin: "8px auto",
  },
  acceptedFiles: {
    margin: 0,
    marginTop: "2px",
    fontWeight: 400,
    color: "#525866",
    fontSize: "12px",
    lineHeight: "16px",
    textAlign: "center",
  },
  replaceFileButton: {
    height: "48px",
    width: "233px",
    marginTop: "20px",
  },
  replaceFileContent: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  replaceFileInfo: {
    fontWeight: 700,
    fontSize: "16px",
    color: "#1E293B",
  },
  importFileButton: {
    height: "48px",
    width: "164px",
    marginTop: "20px",
  },
  importFileContent: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  importFileInfo: {
    fontWeight: 700,
    color: "#FFFFFF",
    fontSize: "16px",
  },
  downloadTemplateBox: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontWeight: 700,
    color: "#F72717",
    fontSize: "16px",
    marginTop: "18px",
    "&:hover": {
      color: "#D21C1C",
      textDecoration: "underline",
      transform: "translateY(-2px)",
    },
    "&:active": {
      color: "#B70000",
      transform: "scale(0.98)",
    },
  },
};
